import { Box, Typography } from "@mui/material";
import React, { useState } from "react";

import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";

export default function InvestmentCard({ portfolioSingleTradeItem }) {
  const [showMore, setShowMore] = useState(false);

  return (
    <Box
      pt={2}
      dir="ltr"
      onClick={() => {
        if (showMore === false) {
          setShowMore(true);
        } else {
          setShowMore(false);
        }
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="start">
        <Box>
          <Typography component="span" display="flex">
            <Typography
              variant="h5"
              color={
                portfolioSingleTradeItem?.side === "Sell"
                  ? "error.main"
                  : "success.main"
              }
            >
              {portfolioSingleTradeItem?.side}
            </Typography>

            <Typography variant="h5" fontWeight={600} pl={1}>
              {portfolioSingleTradeItem?.coinSourceName}/
            </Typography>

            {portfolioSingleTradeItem?.coinDestinationName}

            <Typography
              pl={1}
              variant="h5"
              color={
                portfolioSingleTradeItem?.side === "Sell"
                  ? "error.main"
                  : "Success.main"
              }
            >
              <NumberFormats
                value={portfolioSingleTradeItem?.filled}
                displayType={"text"}
                thousandSeparator={true}
              />
            </Typography>
          </Typography>

          <Typography component="span" display="flex" pt={2}>
            <Typography pr={1} variant="h5">
              Amount
            </Typography>
            <Typography
              color={
                portfolioSingleTradeItem?.side === "Sell"
                  ? "error.main"
                  : "success.main"
              }
            >
              <NumberFormats value={portfolioSingleTradeItem?.total} />
            </Typography>

            <Typography variant="subtitle1" color="text.secondary" pl={1}>
              {portfolioSingleTradeItem?.coinDestinationName}
            </Typography>
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle1" color="text.secondary">
            {portfolioSingleTradeItem?.date}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" pl={1}>
            {portfolioSingleTradeItem?.time}
          </Typography>
        </Box>
      </Box>

      <Box py={2} dir="rtl">
        <Typography color="secondary.main" variant="h4">
          {!showMore ? "+" : "−"}
        </Typography>
      </Box>

      {showMore && (
        <Box>
          <SpaceBetweenBox ml={-1} mr={-1}>
            <Box>
              <Typography component="span" variant="h6" color="text.secondary">
                Wallet:{" "}
              </Typography>
              <Typography
                component="span"
                variant="h6"
                fontWeight={600}
                color="text.main"
              >
                {portfolioSingleTradeItem?.walletType}
              </Typography>{" "}
            </Box>

            <Box>
              <Typography component="span" variant="h6" color="text.secondary">
                Type:{" "}
              </Typography>

              <Typography
                component="span"
                variant="h6"
                fontWeight={600}
                color="text.main"
              >
                {portfolioSingleTradeItem?.type}
              </Typography>
            </Box>
          </SpaceBetweenBox>

          <Typography py={1} variant="h6" display="flex" color="text.secondary">
            Value Time:{" "}
            <Typography
              variant="h6"
              display="flex"
              color="text.main"
              px={0.5}
            >
              <NumberFormats value={portfolioSingleTradeItem?.priceToUSDT} />
            </Typography>{" "}
            USDT
          </Typography>

          <Typography pb={2} variant="h6" display="flex" color="text.secondary">
            Value Time:{" "}
            <Typography
              variant="h6"
              display="flex"
              color="text.main"
              px={0.5}
            >
              <NumberFormats value={portfolioSingleTradeItem?.priceToToman} />
            </Typography>
            Toman
          </Typography>
        </Box>
      )}
    </Box>
  );
}
